import { render, staticRenderFns } from "./AddTucows.vue?vue&type=template&id=7ae01d2b"
import script from "./AddTucows.vue?vue&type=script&lang=js"
export * from "./AddTucows.vue?vue&type=script&lang=js"
import style0 from "./AddTucows.vue?vue&type=style&index=0&id=7ae01d2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports